import * as React from "react";
import {
  BODetailTopBar,
  BODetailTopBarItem
} from "app/components/BOComponents/BODetailTopBar/BODetailTopBar";
import { groupAuth } from "app/utils/authGroups";

const WalletDetailTopbar = ({ wallet }: { wallet: string }) => {
  return (
    <BODetailTopBar>
      <BODetailTopBarItem
        text="Users"
        link={`/snapscan/wallets/${wallet}/users`}
      />
      {groupAuth.hasAccessGroup(["Wallet/Admin"]) ? (
        <BODetailTopBarItem
          text="Add Funds"
          link={`/snapscan/wallets/${wallet}/add_funds`}
        />
      ) : null}
    </BODetailTopBar>
  );
};

export default WalletDetailTopbar;
